import { useMemo } from "react";
import scrollparent from "scrollparent";

export function useScrollableParent(element) {
  return useMemo(() => {
    return scrollparent(element);
  }, [element]);
}
